module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/subject-law-icon-31f6416435d3945b5e87b2d2fdb1a172.svg";